import { DynamicFlowStep } from 'components/common/DynamicFlow'
import { EnergyCertificateStepController } from './EnergyCertificateStep.controller'
import { FC } from 'react'
import { PurchaseFlowStepKey } from '../../../_main/contexts'
import { useEnergyCertificateStep } from './EnergyCertificateStep.context'

/**
 * @component
 * Page in PurchaseFlow step for energy certificate information.
 * 
 * @example 
 * <EnergyCertificateStep />
 */
export const EnergyCertificateStep: FC = () => {

  const {
    isPropertyInformationValid,
    isBuildingLayoutValid,
    isConstructionMethodValid,
    isEnergyAndHeatingValid,
    isAdditionalInformationValid
  } = useEnergyCertificateStep()

  const isValid = isPropertyInformationValid && isBuildingLayoutValid && isConstructionMethodValid && isEnergyAndHeatingValid && isAdditionalInformationValid

  return (
    <DynamicFlowStep
      stepKey={PurchaseFlowStepKey.ENERGY_CERTIFICATE_OF_NEED}
      isValid={isValid}
    >
      <EnergyCertificateStepController />
    </DynamicFlowStep>
  )
}
